
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mois"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_editeur"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRaport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"annee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annee"}}},{"kind":"Argument","name":{"kind":"Name","value":"mois"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mois"}}},{"kind":"Argument","name":{"kind":"Name","value":"last_editeur"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_editeur"}}},{"kind":"Argument","name":{"kind":"Name","value":"total"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rapports"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rapportEditeur"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idClient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Campagnes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leads_brut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leads_net"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"somme_ht"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"somme_ttc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"somme_ht_c"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"langue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trafficManager"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"datecreation_client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MOIS"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ANNEE"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campagne"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Thematique"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Provenance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_type_compagne"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teamManager"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pourcentage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sold"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"soldTTC"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"last_editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1118}};
    doc.loc.source = {"body":"query ($annee: String, $mois: String, $last_editeur: Int, ,$total: Int) {\n    getRaport(annee:$annee, mois:$mois, last_editeur:$last_editeur, total:$total) {\n        rapports {\n            rapportEditeur {\n                ID\n                Editeur\n                Client\n                idClient\n                id_editeur\n                Campagnes\n                Tag\n                clics\n                leads_brut\n                leads_net\n                prix_lead\n                somme_ht\n                somme_ttc\n                prix_client\n                somme_ht_c\n                marge\n                payee\n                langue\n                trafficManager\n                datecreation_client\n                statut_editeur\n                MOIS\n                ANNEE\n                campagne\n                Thematique\n                Provenance\n                id_type_compagne\n                teamManager\n                pourcentage\n            }\n            sold {\n                sold\n                soldTTC\n                etat\n            }\n        }\n        last_editeur\n        total\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
